// extracted by mini-css-extract-plugin
module.exports = {"list":"Itemss_list__SyjNk","card":"Itemss_card__1Vkkf","loader":"Itemss_loader__2AqUB"};